import React from 'react'
import Header from './header'
import 'bootstrap/dist/css/bootstrap.min.css'

export default function Layout (props) {
  return (
    <div>
      <Header {...props} />
      {props.children}
    </div>
  )
}
